import { FunctionComponent, useContext } from "react";

import { TransferContext } from "../../../context/TransferContext";
import { AppContext } from "../../../context/AppContext";
import ScrollableContainer from "../../../layout/scrollable-container";
import Footer from "../../../components/footer";

import { ListContainer, ListItem } from "../../../components/list/List";
import Container from "../../../layout/container";
import { STEP_TRANSFER_INFO } from "../../../class/transferDetails";
import TransitionWrapper from "../../../components/transition-wrapper/TransitionWrapper";
import Highlight from "../../../components/highlight/Highlight";

import { COLOR_WHITE } from "../../../styles/globalStylesVariables";
import Analytics from "../../../utils/productAnalytics";
import Flex from "../../../layout/flex";
import HeadingContainer from "../../../layout/heading-container";
import { TitleLarge } from "../../../components/font";
import { Button, IconProtect, IconTransferout } from "@manifesthhqinc/ui-library";
import { BRIDGE_DEMO } from "../../../typings";

const ConsentPane: FunctionComponent = () => {
  const { partnerConfig, appEnv, flow } = useContext(AppContext);

  const { goToScreen, canStart, transferInstructions, setShouldShowHomeScreen } = useContext(TransferContext);

  return (
    <TransitionWrapper>
      <ScrollableContainer name="consent-pane-content">
        <Container>
          <Flex $flexDirection="column" $height="100%" $justifyContent="flex-start">
            <HeadingContainer withProgressBar={false} paneVariant="form">
              {flow === "Annuity" ? (
                <TitleLarge $textAlign="center">
                  <span data-name="partner-name">{partnerConfig}</span> uses{" "}
                  <Highlight name="highlight-consent-pane">Manifest</Highlight> to fund annuities
                </TitleLarge>
              ) : partnerConfig ? (
                <TitleLarge $textAlign="center">
                  <span data-name="partner-name">{partnerConfig}</span> uses{" "}
                  <Highlight name="highlight-consent-pane">Manifest</Highlight> to <br />
                  transfer old accounts
                </TitleLarge>
              ) : (
                <TitleLarge $textAlign="center">
                  <Highlight name="highlight-consent-pane">Manifest</Highlight> helps you to <br />
                  transfer old accounts
                </TitleLarge>
              )}
            </HeadingContainer>
            <ListContainer name="intro-list" padding="24px 16px" backgroundColor={COLOR_WHITE}>
              <ListItem
                name="transfer-effortlessly"
                icon={<IconTransferout color="dark" size="medium" />}
                heading="Transfer Effortlessly"
                body="We're your companion throughout this journey. All transfers we've initiated have been completed with 100% accuracy."
              />
              <ListItem
                name="trusted-and-secure"
                icon={<IconProtect color="dark" size="medium" />}
                heading="Trusted and secure"
                body="Rest assured, we prioritize your security. Your data is only used with your consent to facilitate transfers."
              />
            </ListContainer>
          </Flex>
        </Container>
      </ScrollableContainer>
      <Footer>
        <p className="text-center disclaimer-text no-max-width">
          By continuing, you agree to our{" "}
          <a
            className="support-link"
            href="https://manifest.helpscoutdocs.com/article/87-terms-of-service"
            target="_blank"
            rel="noreferrer"
          >
            Terms of Service
          </a>{" "}
          and{" "}
          <a
            className="support-link"
            href="https://manifest.helpscoutdocs.com/article/88-privacy-policy"
            target="_blank"
            rel="noreferrer"
          >
            Privacy Policy
          </a>
          . Your plan or account provider may charge fees for this transfer.{" "}
          <a
            className="support-link"
            href="https://manifest.helpscoutdocs.com/article/197-fee-disclosure"
            target="_blank"
            rel="noreferrer"
          >
            Learn more
          </a>
          .
        </p>
        <Button
          onClick={() => {
            Analytics.track({
              name: "Clicked Continue on Consent Pane",
            });
            if (appEnv === BRIDGE_DEMO && transferInstructions.length > 0) {
              setShouldShowHomeScreen(true);
            } else {
              goToScreen(STEP_TRANSFER_INFO);
            }
          }}
          name="learnMore"
          isLoading={!canStart}
          size="large"
        >
          Continue
        </Button>
      </Footer>
    </TransitionWrapper>
  );
};

export default ConsentPane;
